import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkforcePositionLabelComponent } from './workforce-position-label.component';

@NgModule({
  declarations: [WorkforcePositionLabelComponent],
  imports: [CommonModule],
  exports: [WorkforcePositionLabelComponent],
})
export class WorkforcePositionLabelModule {}
